import { useIntl } from 'react-intl';
import { Select, SelectOption, SelectProps } from '@ets/design-system';

export type RoleOption = SelectOption;

export type RoleSelectProps<
  Option extends RoleOption = RoleOption,
  IsMulti extends boolean = false,
> = Omit<
  SelectProps<Option, IsMulti>,
  | 'variant'
  | 'isMulti'
  | 'menuPosition'
  | 'selectedGroupLabel'
  | 'unselectedGroupLabel'
  | 'overflowLabel'
>;

const RoleSelect = <Option extends RoleOption = RoleOption>(
  props: RoleSelectProps<Option, true>,
) => {
  const intl = useIntl();
  return (
    <Select
      {...props}
      variant="standard"
      isMulti
      menuPosition="fixed"
      styles={{
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 7,
        }),
      }}
      groupOptionsBySelection
      selectedGroupLabel={(selected) =>
        `${intl.formatMessage({
          id: 'SELECTED_ROLES',
        })} (${selected})`
      }
      unselectedGroupLabel={intl.formatMessage({
        id: 'UNSELECTED_ROLES',
      })}
      overflowLabel={(selected) => {
        return `${selected} ${intl.formatMessage(
          {
            id: 'ROLES_SELECTED',
          },
          { total: selected },
        )}`;
      }}
    />
  );
};

export default RoleSelect;
